/*
 * File: cell-user-status.ts
 * Created: 2025-12-05 17:44:40
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-05 17:44:55
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

/* src/lib/components/table/lib/cell-user-status/cell-user-status.ts */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiAlign: "center", // 狀態欄位建議置中
})
export default class CellUserStatus extends BaseTableBodyCell {
    // 取得布林值狀態
    get isActive(): boolean {
        return !!this.value;
    }

    // 取得顯示文字 (建議使用翻譯 Key)
    get statusLabel(): string {
        // 這裡假設您有對應的翻譯鍵值，若無可直接回傳英文 "Active" / "Disabled"
        return this.isActive ? "w_StatusActive" : "w_StatusDisabled";
    }
}
